import { useEffect, useState } from "react";
import Calender from "react-calendar";
import styled from "styled-components";
import { IoWarningOutline } from "react-icons/io5";
import "./Calendar.css";
import {
  CustomNumberField,
  CustomSelectField,
  CustomeCkeckboxField,
} from "../../../components/customFormField";
import { Notify, Utils } from "../../../utils";
import { CustomButton } from "../../../components/customButton";
import {
  LeaveService,
  PayrollService,
  S3Service,
  UserService,
} from "../../../_service";
import { useAppSelector } from "../../../_app";
import { LeaveDatePicker } from "../component";
import { Constant } from "../../../config";
import { LeaveRecordTakenText } from "./LeaveStyles";
import { useLocation, useNavigate } from "react-router-dom";
import LeaveInstructions from "./LeaveInstructions";

interface SelectedListProps {
  date: string;
  is_partial: boolean;
  factor: string;
  hours: string;
}

// Helper functions
const isWeekend = (date: Date) => [0, 6].includes(date.getDay());
const getDatesInRange = (startDate: any, endDate: any) => {
  const _date = new Date(startDate.getTime());
  const dates = [];
  while (_date <= endDate) {
    dates.push(new Date(_date));
    _date.setDate(_date.getDate() + 1);
  }
  return dates;
};
const isGreater = (d1: Date, d2: Date) => {
  let date1 = new Date(d1).getTime();
  let date2 = new Date(d2).getTime();

  if (date1 < date2) {
    return false;
  } else if (date1 > date2) {
    return true;
  } else {
    return false;
  }
};
const checkDateEquality = (date1: any, date2: any): boolean =>
  date1.getFullYear() === date2.getFullYear() &&
  date1.getMonth() === date2.getMonth() &&
  date1.getDate() === date2.getDate();

interface LeaveBalance {
  last_updated: string;
  leave_balance: number;
  leave_name: string;
  leave_type: number;
}
const LeaveRecordTaken = () => {
  let empId = useAppSelector(
    (state) => state.employee.employee_info.id || state.user.employee_id
  );
  const companyId = useAppSelector((state) => state.user.defaultCompnayId);

  const [holidayList, setHolidayList] = useState<string[]>([]);
  const [date, setDate] = useState<any>();
  const [currentSelected, setCurrentSelected] = useState<{
    startDate?: string;
    endDate?: string;
    currentYear: string;
  }>(() => ({
    currentYear: `${new Date().getFullYear()}`,
  }));
  const [selectedList, setSelectedList] = useState<SelectedListProps[]>([]);
  const [hoursPerDay, setHoursPerDay] = useState<number>(8);
  const [leaveType, setLeaveType] = useState<string>();
  const [leaveTypeList, setLeaveTypeList] = useState([]);
  const [blackoutDates, setBlackoutDates] = useState<string[]>([]);
  const [calenderData, setCalenderData] = useState([]);
  const [updateData, setUpdateData] = useState({ is: false, id: "" });
  const [error, setError] = useState(0);
  const [leaveBalancesList, setLeaveBalancesList] = useState<LeaveBalance[]>(
    []
  );
  const [isLeaveApproved, setIsLeaveApproved] = useState<boolean>(false);

  const [selfServiceRequests, setSelfServiceRequests] = useState<any[]>([]);

  const [visibleCalendarYear, setVisibleCalendarYear] = useState(
    new Date().getFullYear()
  );

  const [showConfirmation, setShowConfirmation] = useState(false);

  const [projectedBalanceData, setProjectedBalanceData] = useState<any>({
    projected_balance: [],
    error: null,
    warning: null,
  });

  const location = useLocation();
  const navigate = useNavigate();

  // check date include in holiday list
  const isHolidayLeave = (date: Date): boolean =>
    holidayList.includes(Utils._date(date));

  // disable date eg. holiday and weekend
  const isDisable = (date: Date) =>
    holidayList.includes(Utils._date(date)) || isWeekend(date);

  // Customize tile content based on the date (view month) and Return null for other dates
  const tileContent = ({ date, view }: any): React.ReactNode =>
    view === "month" && isHolidayLeave(date) ? (
      <div className="highlight-weekend">Public Holiday</div>
    ) : null;

  // get data by date
  const handleGetDataByDate = (date: string) => {
    let dateJson;
    if (blackoutDates.some((_) => _ === Utils._date(date))) {
      const _: any = calenderData.filter((item: any) => {
        return item.date_json.some((i: any) => i.date === Utils._date(date));
      });
      dateJson = _?.[0]?.date_json
        ?.filter((d_j: any) => d_j.date === Utils._date(date))
        ?.flat();
    } else {
      dateJson = {
        date: date,
        is_partial: false,
        factor: "0",
        hours: "0",
      };
    }
    return dateJson;
  };
  // handle on calender date change
  const handleCalenderDateChange = (date: any) => {
    setError(0);
    if (currentSelected.currentYear != Utils._date(date)) {
      setCurrentSelected((prev) => ({
        ...prev,
        currentYear: `${new Date(date).getFullYear()}`,
      }));
      handleLeaveRecordData("get");
    }
    if (blackoutDates.some((_) => _ === Utils._date(date))) {
      const _: any = calenderData
        .filter((item: any) => {
          return item.date_json.some((i: any) => i.date === Utils._date(date));
        })
        ?.flat();
      const dateJson = _?.[0]?.date_json,
        from = _?.[0]?.date_from,
        to = _?.[0]?.date_to,
        id = _?.[0]?.id;
      setIsLeaveApproved(() => (_[0].is_approved !== null ? true : false));
      setSelectedList(() => dateJson);
      setCurrentSelected((prev) => ({ ...prev, startDate: from, endDate: to }));
      setUpdateData((prev) => ({ ...prev, is: true, id: id }));
      setDate(() => Utils._date(from));
    } else {
      setCurrentSelected((prev) => ({
        ...prev,
        startDate: Utils._date(date) || "",
        endDate: Utils._date(date) || "",
      }));
      setIsLeaveApproved(() => false);
      setDate(() => Utils._date(date));
      setUpdateData((prev) => ({ ...prev, is: false, id: "" }));
    }
  };
  // update selected date list/info
  const updateSelectedList = (
    type: "hour" | "partial",
    item: SelectedListProps,
    value: string | boolean
  ) => {
    const _dataList = JSON.parse(JSON.stringify(selectedList));
    if (type === "hour") {
      _dataList?.map((prev: any) => {
        if (prev?.date === item.date && typeof value === "string") {
          return Object.assign(prev, {
            hours: value,
            factor: parseFloat(value) / hoursPerDay,
          });
        }
        return prev;
      });
    } else {
      _dataList?.map((prev: any) => {
        if (prev?.date === item.date) {
          if (value) {
            return Object.assign(prev, {
              is_partial: value,
              hours: hoursPerDay / 2,
              factor: hoursPerDay / 2 / hoursPerDay,
            });
          } else {
            return Object.assign(prev, {
              is_partial: value,
              hours: "0",
              factor: "0",
            });
          }
        }
        return prev;
      });
    }
    setSelectedList(() => _dataList);
  };
  // get date range and filter weekends
  const getFilteredDatesInRange = (startDate: any, endDate: any) => {
    const _date = new Date(startDate.getTime());
    const dates = [];
    while (_date <= endDate) {
      if (!isDisable(_date)) {
        dates.push(handleGetDataByDate(Utils._date(_date)));
      }
      _date.setDate(_date.getDate() + 1);
    }
    return dates?.flat();
  };

  // get weekends count in date range
  const getWeekendsCount = (startDate: any, endDate: any) => {
    const _date = new Date(startDate.getTime());
    let count: number = 0;
    while (_date <= endDate) {
      if (isDisable(_date)) {
        count += 1;
      }
      _date.setDate(_date.getDate() + 1);
    }
    return count;
  };

  useEffect(() => {
    if (
      isGreater(
        new Date(currentSelected?.startDate || ""),
        new Date(currentSelected?.endDate || "")
      )
    ) {
      setCurrentSelected((prev) => ({
        ...prev,
        endDate: currentSelected?.startDate,
      }));
      setSelectedList(() =>
        getFilteredDatesInRange(
          new Date(currentSelected?.startDate || ""),
          new Date(currentSelected?.startDate || "")
        )
      );
    } else {
      setSelectedList(() =>
        getFilteredDatesInRange(
          new Date(currentSelected?.startDate || ""),
          new Date(currentSelected?.endDate || "")
        )
      );
    }
    setError(0);
  }, [currentSelected?.startDate, currentSelected?.endDate]);

  const getHoursPerDay = async () => {
    try {
      const res = await PayrollService._getWorkingHours(empId, companyId);
      if (res.status === 200) {
        setHoursPerDay(() =>
          res?.data?.hours_per_day ? res?.data?.hours_per_day : 8
        );
      }
    } catch (e: any) {
      if (e?.response?.status === 401) {
        // disaptch(resetUser());
      }
    }
  };

  const getLeaveTypes = async () => {
    try {
      const res = await LeaveService._getLeaveTypes(parseInt(companyId));
      if (res.status === 200) {
        setLeaveType(() => res?.data?.data?.[0]?.id);
        setLeaveTypeList(() =>
          res?.data?.data?.map((item: any) => ({
            key: item?.name,
            value: item?.id,
          }))
        );
      }
    } catch (e: any) {
      if (e?.response?.status === 401) {
        // disaptch(resetUser());
      }
    }
  };
  const getLeaveBalance = async () => {
    try {
      const res = await LeaveService._getLeaveBalance(
        empId,
        `${currentSelected.currentYear}-01-01`,
        `${currentSelected.currentYear}-12-31`,
        companyId
      );
      if (res.status === 200) {
        const _leaveBalanceList: any = Object.entries(res.data.data).map(
          (item) => item[1]
        );
        setLeaveBalancesList(() => _leaveBalanceList.flat());
      }
    } catch (e: any) {
      console.error(e);
    }
  };
  const handleLeaveRecordData = async (
    type: "get" | "update" | "add" | "del",
    data?: any
  ) => {
    try {
      if (type === "get") {
        const res = await LeaveService._getLeaveRecordTaken(
          empId,
          `${currentSelected.currentYear}-01-01`,
          `${currentSelected.currentYear}-12-31`
        );
        if (res.status === 200) {
          setCalenderData(() => res.data.data);
          const _dates = res.data.data.map((item: any) =>
            item.date_json.map((_item: any) => _item.date)
          );
          setBlackoutDates(() => _dates?.flat());
        }
      }
      if (type === "add") {
        let errorCount = 0;
        data.date_json.forEach((item: any) => {
          if (parseFloat(item.hours) > hoursPerDay) {
            errorCount += 1;
          }
        });
        setError(() => errorCount);
        if (errorCount > 0) {
          return;
        }
        const res = await LeaveService._postLeaveRecordTaken(data);
        if (res.status === 201) {
          Notify("Leave add successfully", 1);
          if (location.pathname === "/dashboard/requests/leave") {
            navigate(-1);
          } else {
            // handleLeaveRecordData("get");
            // setDate(null);
            // setCurrentSelected((prev) => ({
            //   ...prev,
            //   startDate: "",
            //   endDate: "",
            // }));
            resetState();
          }
        }
      }
      if (type === "update") {
        let errorCount = 0;
        data.date_json.forEach((item: any) => {
          if (parseFloat(item.hours) > hoursPerDay) {
            errorCount += 1;
          }
        });
        setError(() => errorCount);
        if (errorCount > 0) {
          return;
        }
        const res = await LeaveService._patchLeaveRecordTaken(
          data,
          updateData.id
        );
        if (res.status === 200) {
          Notify("Leave updated successfully", 1);
          resetState();
        }
      }
      if (type === "del") {
        const res = await LeaveService._deleteLeaveRecordTaken(
          data,
          updateData.id
        );
        if (res.status === 200) {
          Notify("Leave deleted successfully", 1);
          if (location.pathname === "/dashboard/requests/leave") {
            navigate(-1);
          } else {
            // handleLeaveRecordData("get");
            // setDate(null);
            // setCurrentSelected((prev) => ({
            //   ...prev,
            //   startDate: "",
            //   endDate: "",
            // }));
            resetState();
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getLeaveList = async () => {
    try {
      const res = await S3Service._getCalenderLeaveList(
        currentSelected.currentYear
      );
      const _holidayList = res?.data?.map(
        (item: { Date: string }) => item.Date
      );
      setHolidayList(() => _holidayList);
    } catch (error) {
      console.error(error);
    }
  };

  const resetState = () => {
    setDate(null);
    setCurrentSelected({
      startDate: "",
      endDate: "",
      currentYear: `${new Date().getFullYear()}`,
    });
    setSelectedList([]);
    setUpdateData({ is: false, id: "" });
    setLeaveType(leaveTypeList?.[0]?.value);
    setIsLeaveApproved(false);
    setShowConfirmation(false);
    
    // Trigger useEffect to reload data
    getHoursPerDay();
    getLeaveTypes();
    getLeaveList();
    handleLeaveRecordData("get");
    getLeaveBalance();
    getSelfServiceRequests();
    setProjectedBalanceData({ projected_balance: [], error: null, warning: null });
  };

  const handleConfirm = (del: boolean = false) => {
    console.log("handleConfirm", del, selectedList);
    let data = {
      employee: empId,
      company: companyId,
      leave_type: leaveType,
      date_from: currentSelected.startDate,
      date_to: currentSelected.endDate,
      date_json: selectedList,
    };
    if (updateData.is) {
      if (del) {
        handleLeaveRecordData("del", data);
      } else {
        handleLeaveRecordData("update", data);
      }
    } else {
      handleLeaveRecordData("add", data);
    }
  };

  const getProjectedBalance = async () => {
    let data = {
      employee: empId,
      company: companyId,
      leave_type: leaveType,
      date_from: currentSelected.startDate,
      date_to: currentSelected.endDate,
      date_json: selectedList,
    };

    try {
      const res = await LeaveService._getProjectedLeaveBalance(data);
      if (res.status >= 200 && res.status < 300) {
        console.log("Projected Leave Balance:", res.data.data);
        setProjectedBalanceData(() => ({
          projected_balance: res.data.data.projected_balance,
          error: res.data.data.error,
          warning: res.data.data.warning
        }));

        if(!res.data.data.error){
          setShowConfirmation(true)
        }
      }
    } catch (error:any) {
      Utils.showErrorMessage(error);
    }
  };

  const getSelfServiceRequests = async () => {
    // setIsLoading(() => true);
    let fromDate = "";
    let toDate = "";
    try {
      const { data, status } = await LeaveService._getSelfServiceLeaveRequests(
        empId,
        `${visibleCalendarYear}-01-01`,
        `${visibleCalendarYear}-12-31`,
        0
      );
      if (status === 200) {
        setSelfServiceRequests(() => data.data);
      }
    } catch (error: any) {
      Utils.showErrorMessage(error);
    }
    // setIsLoading(() => false);
  };


const getLeaveBalances = () => {
  const leaveBalances:any = leaveBalancesList?.find(
    (item: any) => item.leave_type === parseInt(leaveType || "0")
  );
  return leaveBalances?.leave_balance;
};

const getLeaveName = (value:any) => {
    const leave:any = leaveTypeList?.find((leave:any) => leave.value === parseInt(value));
    return leave ? leave.key : 'Leave';
}


const countLeaveDays = (data) => {
    let totalDays = 0;
    data.forEach((item) => {
        const factor = parseFloat(item.factor);
        totalDays += factor === 0 ? 1 : factor;
    });
    return totalDays;
};

  useEffect(() => {
    getHoursPerDay();
    getLeaveTypes();
    getLeaveList();
    handleLeaveRecordData("get");
    getLeaveBalance();
    getSelfServiceRequests();
  }, []);

  // UI marker
  const WEEKENDS_COUNT = getWeekendsCount(
    new Date(currentSelected?.startDate || ""),
    new Date(currentSelected?.endDate || "")
  );

  console.log("visibleYear", visibleCalendarYear, selfServiceRequests);

  console.log("Projected Balance Data:", projectedBalanceData);

  return (
    <>
      {showConfirmation && (
        <div style={{ display: "flex", gap: "24px", padding: "24px" }}>
          <div
            style={{
              flex: 1,
              borderRadius: "4px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              backgroundColor: "#fff",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "12.8px 16px",
                borderBottom: "1px solid #eee",
                backgroundColor: "#4a5e71",
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontSize: "1.125rem",
                  color: "#fff",
                  fontWeight: 600,
                }}
              >
                Pending Changes
              </p>
            </div>

            <div style={{ padding: "20px 24px" }}>
              <p
                style={{
                  margin: "0 0 16px 0",
                  color: "#666",
                  fontSize: "0.875rem",
                }}
              >
                Are you sure you want to save these changes?
              </p>

              <p
                style={{
                  color: "#1e293b",
                  fontSize: "1rem",
                  fontWeight: 500,
                  padding: "12px 16px",
                  backgroundColor: "#f1f5f9",
                  borderRadius: "6px",
                  marginBottom: "20px",
                }}
              >
                Adding: {selectedList?.length} days of {getLeaveName(leaveType)}{" "}
                Leave
              </p>

              <div
                style={{
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                {selectedList.map((item, index) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "14px 20px",
                        borderBottom:
                          index !== selectedList.length - 1
                            ? "1px solid #e2e8f0"
                            : "none",
                        backgroundColor: index % 2 === 0 ? "#f8fafc" : "#fff",
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          fontSize: "0.925rem",
                          color: "#334155",
                          fontWeight: 500,
                        }}
                      >
                        {Utils._dateToShow(item.date)}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "0.925rem",
                          color: "#64748b",
                          textAlign: "right",
                        }}
                      >
                        {getLeaveName(leaveType)}{" "}
                        {item.is_partial ? `(Half-Day)` : "(Full Day)"}
                      </p>
                    </div>
                  );
                })}
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  marginTop: "24px",
                  justifyContent: "flex-end",
                }}
              >
                <CustomButton
                  onClick={() => handleConfirm()}
                  title="Confirm"
                />
                <CustomButton
                  type="secondary"
                  // onClick={() => navigate("/dashboard/employee-payroll")}
                  onClick={resetState}
                  title="Cancel"
                />
              </div>
            </div>
          </div>
          <div
            style={{
              flex: 1,
              // padding: "1rem",
              border: "1px solid #ddd",
              borderRadius: "8px",
            }}
          >
            <div
              style={{
                background: "#f5f5f5",
                // padding: "10px 1rem",
                borderRadius: "4px",
                marginBottom: "1rem",
              }}
            >
              <div
                style={{
                  background: "#4a5e71",
                  padding: "0.8rem 1rem",
                  borderRadius: "4px",
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    color: "#fff",
                    fontSize: "18px",
                  }}
                >
                  Projected Leave Balance
                </h3>
              </div>
            </div>
            <p
              style={{
                color: "#666",
                fontSize: "0.875rem",
                margin: "0.75rem 0",
                lineHeight: "1.5",
                padding: "0 1rem",
              }}
            >
              The following table shows how this request will affect this
              employee's leave balances:
            </p>

            {projectedBalanceData?.warning &&
              projectedBalanceData.warning.trim() !== "" && (
                <div
                  style={{
                    margin: "1rem",
                    padding: "12px 16px",
                    backgroundColor: "#fefce8",
                    border: "1px solid #fde047",
                    borderRadius: "8px",
                    borderLeft: "4px solid #eab308",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "12px",
                    }}
                  >
                    <IoWarningOutline
                      style={{ color: "#eab308", fontSize: "1.5rem" }}
                    />
                    <div>
                      <p
                        style={{
                          color: "#92400e",
                          fontSize: "1rem",
                          margin: 0,
                          lineHeight: "1.5",
                        }}
                      >
                        {/* Applying for <strong>{selectedList?.length}</strong> days of leave will make your{" "}
                    <strong>{getLeaveName(leaveType)}</strong> balance {" "}
                    <strong>{(getLeaveBalances() - selectedList?.length)}</strong>. */}
                        {projectedBalanceData?.warning}
                      </p>
                    </div>
                  </div>
                </div>
              )}

            <div style={{ padding: "1rem" }}>
              <Table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th style={{ textAlign: "center" }}>
                      {getLeaveName(leaveType)}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {projectedBalanceData?.projected_balance.map(
                    (item, index) => {
                      return (
                        <tr>
                          <td>{Utils._dateToShow(item.date)}</td>
                          <td style={{ textAlign: "center" }}>
                            {/* {getLeaveBalances() - (index + 1)} */}
                            {item.balance || 0}
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      )}

      <div className="calender-container">
        <p className="title">Record Leave</p>
        <div style={{ paddingLeft: 10 }}>
          <CustomSelectField
            title="Type:"
            value={leaveType}
            option={leaveTypeList}
            onChangeOption={(val) => setLeaveType(val)}
            width="300px"
          />
        </div>
        <LeaveRecordTakenText>
          Select a date from the calendar to begin adding leave days.
        </LeaveRecordTakenText>
        <MiddleContainer>
          <div className="calender-wrapper">
            <div className="cal-wrap">
              <Calender
                tileContent={tileContent}
                value={date}
                calendarType="US"
                tileDisabled={({ date }) => isDisable(date)}
                tileClassName={({ date, view }) => {
                  if (
                    blackoutDates.find((x) =>
                      checkDateEquality(new Date(x), new Date(date))
                    )
                  ) {
                    return "highlight";
                  }
                  if (
                    getDatesInRange(
                      new Date(currentSelected?.startDate || ""),
                      new Date(currentSelected?.endDate || "")
                    ).find((x) =>
                      checkDateEquality(new Date(x), new Date(date))
                    )
                  ) {
                    return "current-highlight";
                  }
                }}
                onActiveStartDateChange={({ activeStartDate }) => {
                  console.log(
                    "Month:",
                    activeStartDate?.getMonth() + 1,
                    "Year:",
                    activeStartDate?.getFullYear()
                  );
                  // setVisibleCalendarMonthYear({
                  //   month: activeStartDate?.getMonth() + 1,
                  //   year: activeStartDate?.getFullYear(),
                  // });
                  setVisibleCalendarYear(activeStartDate?.getFullYear());
                }}
                onChange={(date: any) => {
                  setShowConfirmation(false);
                  handleCalenderDateChange(date);
                }}
              />
            </div>
            {date && (
              <div className="mp-1" style={{ marginLeft: "1rem" }}>
                {WEEKENDS_COUNT ? (
                  <p className="red">
                    {WEEKENDS_COUNT} dates were excluded because they were
                    holiday or weekend days.
                  </p>
                ) : null}
                <div className="flex">
                  <div className="mep5">
                    <b>From:</b>
                    <LeaveDatePicker
                      date={currentSelected?.startDate || date}
                      setDate={(val: any) => {
                        setCurrentSelected((prev) => ({
                          ...prev,
                          startDate: val,
                        }));
                        setDate(() => val);
                      }}
                      margin="0.2rem"
                      filterDate={(date) => {
                        // Disable weekends (Saturday and Sunday)
                        return !isWeekend(date);
                      }}
                    />
                  </div>
                  <div>
                    <b>To:</b>
                    <LeaveDatePicker
                      date={currentSelected?.endDate || date}
                      minDate={
                        currentSelected.startDate
                          ? new Date(currentSelected.startDate)
                          : null
                      }
                      margin="0.2rem"
                      setDate={(val: any) =>
                        setCurrentSelected((prev) => ({
                          ...prev,
                          endDate: val,
                        }))
                      }
                      filterDate={(date) => {
                        // Disable weekends (Saturday and Sunday)
                        return !isWeekend(date);
                      }}
                    />
                  </div>
                </div>
                <div>
                  {selectedList?.length > 0 && (
                    <Table>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Partial</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedList?.map((item) => {
                          return (
                            <tr key={item.date}>
                              <td style={{ width: "150px" }}>
                                {Utils._dateToShow(item.date)}
                              </td>
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                  }}
                                >
                                  <CustomeCkeckboxField
                                    onChange={() =>
                                      updateSelectedList(
                                        "partial",
                                        item,
                                        !item.is_partial
                                      )
                                    }
                                    title=""
                                    value={item.is_partial}
                                    width="40px"
                                  />
                                  {/* {item.is_partial && (
                                  <div className="number-field-wrap">
                                    <CustomNumberField
                                      value={item.hours}
                                      onChangeText={(value) => {
                                        updateSelectedList("hour", item, value);
                                      }}
                                      width="40px"
                                      marginTop="0"
                                    />
                                    <p className="text-wrap">
                                      of {hoursPerDay} hours
                                    </p>
                                  </div>
                                )} */}
                                  {item.is_partial && (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <p
                                        style={{
                                          margin: 0,
                                          fontSize: "1rem",
                                          color: "#37353E",
                                          fontWeight: 600,
                                          padding: "5px 10px",
                                          backgroundColor: "#FBFBFB",
                                          borderRadius: "4px",
                                          border: "1px solid #37353E",
                                        }}
                                      >
                                        {"0.5"}
                                      </p>
                                      <span>of 1 day</span>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  )}
                  {error !== 0 && (
                    <>
                      <ErrorText>
                        You have selected invalid hours for {error} days.
                      </ErrorText>
                      <ErrorText>
                        Please correct the values before saving
                      </ErrorText>
                    </>
                  )}
                </div>
                {!isLeaveApproved && (
                  <div>
                    <div className="flex mp-1" style={{ marginBottom: "1rem" }}>
                      <CustomButton
                        onClick={() => {
                          // setShowConfirmation(true);
                          setDate(null);
                          getProjectedBalance();
                        }}
                        title="Confirm"
                        width="100px"
                      />
                      <CustomButton
                        type="secondary"
                        onClick={() => {
                          setDate(null);
                        }}
                        title="Cancel"
                        width="100px"
                      />
                    </div>

                    {/* Project Balance Error */}
                    {projectedBalanceData.error && (
                      <div
                        style={{
                          margin: "1rem",
                          padding: "12px 16px",
                          backgroundColor: "#fef2f2",
                          border: "1px solid #fecaca",
                          borderRadius: "8px",
                          borderLeft: "4px solid #ef4444",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <IoWarningOutline
                            size={20}
                            style={{ color: "#ef4444" }}
                          />
                          <span style={{ color: "#dc2626" }}>
                            {projectedBalanceData.error}
                          </span>
                        </div>
                      </div>
                    )}

                    {updateData.is && (
                      <div className="mp-1">
                        <CustomButton
                          del
                          width="150px"
                          type="secondary"
                          onClick={() => handleConfirm(true)}
                          title="Remove Dates"
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Message box */}
          <LeaveInstructions />
        </MiddleContainer>
      </div>

      <div style={{ display: "flex", gap: "2rem", marginTop: "2rem" }}>
        {selfServiceRequests.length > 0 && (
          <div
            className="leave-container"
            style={{ flex: 1, minWidth: "600px" }}
          >
            <p className="title">Self-Service Leave Requests</p>
            <div style={{ padding: "1rem" }}>
              <Table style={{ minWidth: "100%" }}>
                <thead>
                  <tr>
                    <th style={{ minWidth: "7.5rem" }}>Type</th>
                    <th style={{ minWidth: "6.25rem" }}>From Date</th>
                    <th style={{ minWidth: "6.25rem" }}>To Date</th>
                    <th style={{ minWidth: "5rem", textAlign: "center" }}>
                      Days
                    </th>
                    <th style={{ minWidth: "6.25rem" }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {selfServiceRequests.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.leave_name}</td>
                        <td>{Utils._dateToShow(item.date_from)}</td>
                        <td>{Utils._dateToShow(item.date_to)}</td>
                        <td style={{ minWidth: "80px", textAlign: "center" }}>
                          {/* {Utils.getDaysCount(item.date_from, item.date_to)} */}
                          {countLeaveDays(item.date_json)}
                        </td>
                        <td>
                          <span
                            style={{
                              fontWeight: 500,
                              color:
                                item?.is_approved === null
                                  ? "#f59e0b"
                                  : item?.is_approved
                                  ? "#10b981"
                                  : "#ef4444",
                            }}
                          >
                            {item?.is_approved === null
                              ? "Pending"
                              : item?.is_approved
                              ? "Approved"
                              : "Rejected"}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        )}

        {leaveBalancesList.length > 0 && (
          <div className="leave-container" style={{ flex: 1 }}>
            <p className="title">Leave Balances</p>
            <div style={{ padding: "1rem" }}>
              <Table>
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Days</th>
                    <th>Last Updated</th>
                  </tr>
                </thead>
                <tbody>
                  {leaveBalancesList.map((item) => {
                    return (
                      <tr key={item.leave_type}>
                        <td>{item.leave_name}</td>
                        <td>{Utils.formatToTwoDecimals(item.leave_balance)}</td>
                        <td>{Utils._dateToShow(item.last_updated)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <Span>
                These balances take into account days included in pending leave
                requests.
              </Span>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default LeaveRecordTaken;

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  text-align: left;
  th {
    padding: 0.25rem;
  }
  td {
    height: 40px;
  }
  tr {
    background-color: #fff;
  }
  tbody {
    tr:nth-child(odd) {
      background-color: #f2f2f2;
    }
    tr:nth-child(even) {
      background-color: #fff;
    }
  }
`;
const ErrorText = styled.p`
  color: red;
`;
const Span = styled.span`
  font-size: 0.8rem;
  color: #6c757d;
`;

const MiddleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
`;
